import React from 'react';
import useReveal from '../useReveal';
import './AIEStepsStrip.css';

/**
 * AIEStepsStrip — the Paperclip-style second fold (mock ruling #2, Aug 5):
 * H2 "Manage outcomes, not prompts." + a 3-step strip. NO eyebrow, no prose
 * contrast paragraph, no table — the three steps ARE the difference statement.
 *
 * Reuse (Sep 23 2026): role pages pass their own `title`, `steps` and an
 * optional `eyebrow` (no HowTo schema, Google retired it in 2023). Defaults
 * are the /ai-employees values, so that page renders exactly as before.
 */
const STEPS = [
  {
    n: '01',
    title: 'Hire in one line.',
    body: <span className="aie-steps__quote">&ldquo;Hire a marketing manager for Acme.&rdquo;</span>,
  },
  {
    n: '02',
    title: 'Grant the rails.',
    body: 'Connect the tools, set the permissions, decide what needs your approval.',
  },
  {
    n: '03',
    title: 'Watch them work.',
    body: 'Real shifts, their own task board, a written report back to you. Redirect any time.',
  },
];

const DEFAULT_TITLE = (
  <>
    Manage outcomes,
    <br />
    not prompts.
  </>
);

const AIEStepsStrip = ({ title = DEFAULT_TITLE, steps = STEPS, eyebrow = null }) => {
  const [ref, visible] = useReveal();

  return (
    <section className="aie-steps aie-section">
      <div className="aie-section-head">
        {eyebrow && <span className="rolp-eyebrow">{eyebrow}</span>}
        <h2 className="aie-section-title aie-display aie-steps__h2">{title}</h2>
      </div>
      <div className={`aie-steps__strip aie-reveal ${visible ? 'is-visible' : ''}`} ref={ref}>
        {steps.map((s) => (
          <div className="aie-steps__step" key={s.n}>
            <span className="aie-steps__n">{s.n}</span>
            <h3>{s.title}</h3>
            <p>{s.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AIEStepsStrip;
